import React, {useEffect} from "react";
import {Button, Col, DatePicker, Form, Image, Input, message, Row, Upload, UploadProps} from "antd";
import {useStore} from "../../../store";
import {DetailType, ManagerBusinessType} from "../../../common/Constant";
import moment from "moment";
import {forEach} from "lodash";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../../config/serviceLoading";
import {addAtlasInfo, addDnaInfo, editAtlasInfo, editDnaInfo, uploadSpecimenPictureApi} from "../../../http/manager";
import {BaseImageUrl} from "../../../http/http";
import {UploadOutlined} from "@ant-design/icons";
import {observer} from "mobx-react";
import styled from "styled-components";

const defaultIcon = require("../../../image/default-pic.png")

interface DnaProps {
    onSuccess: () => void;
}
const DnaEdit:React.FC<DnaProps> = ({onSuccess}) => {
    const [form] = Form.useForm();
    const {dnaLibraryStore} = useStore();

    useEffect(() => {
        if (dnaLibraryStore.detailType === DetailType.EDIT) {
            const {detailEntity} = dnaLibraryStore;
            const detail = JSON.parse(JSON.stringify(detailEntity));
            if (detail && detail.sequenceTime) {
                detail.sequenceTime = moment(detail.sequenceTime)
            }
            form.setFieldsValue(detail);
        }
        dnaLibraryStore.srcFile = null
        dnaLibraryStore.clearFileList();
        // return form.resetFields();
    }, []);

    const submit = () => {
        const formFields = form.getFieldsValue(true);
        const formKeys = Object.keys(formFields);
        if (dnaLibraryStore.detailType === DetailType.ADD && dnaLibraryStore.fileList.length <= 0) {
            message.error("请选择照片");
            return;
        }
        form.validateFields()
            .then((values) => {
                const formData = new FormData();
                forEach(formKeys, (key) => {
                    if (key === "sequenceTime") {
                        formData.append(key, moment(formFields[key]).format("YYYY-MM-DD"))
                    } else {
                        formData.append(key, formFields[key]);
                    }
                })
                showFullScreenLoading()

                if (dnaLibraryStore.detailType === "add") {
                    addDnaInfo(formData)
                        .then((res) => {
                            if (Number(res.code) === 200) {
                                uploadPicture(res.data);
                            } else {
                                tryHideFullScreenLoading();
                                message.error("新增失败");
                            }
                        }).catch(() => {
                        message.error("新增失败");
                        tryHideFullScreenLoading()
                    })
                } else {
                    editDnaInfo(formData)
                        .then((res) => {
                            if (Number(res.code) === 200) {
                                if (dnaLibraryStore.fileList.length <= 0) {
                                    message.success("编辑成功");
                                    tryHideFullScreenLoading()
                                    onSuccess();
                                } else {
                                    uploadPicture(res.data, false);
                                }
                            } else {
                                tryHideFullScreenLoading();
                                message.error("编辑失败");
                            }
                        }).catch(() => {
                        message.error("编辑失败");
                        tryHideFullScreenLoading()
                    })
                }
            })
            .catch();
    }

    const uploadPicture = (data: any, isAdd = true) => {
        const params = new FormData();
        if (dnaLibraryStore.detailType === "edit") {
            params.append("id", String(dnaLibraryStore.detailEntity!.id));
        } else {
            params.append("id", data.id);
        }
        params.append("type", ManagerBusinessType.DNA+"")
        params.append("file", dnaLibraryStore.fileList[0]);
        uploadSpecimenPictureApi(params)
            .then((res) => {
                tryHideFullScreenLoading()
                if (Number(res.code) === 200) {
                    message.success(isAdd ? "新增成功" : "编辑成功");
                    onSuccess();
                } else {
                    message.error(isAdd ? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
                }
            }).catch(() => {
            message.error(isAdd ? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
            tryHideFullScreenLoading()
        })
    }

    const props: UploadProps = {
        onRemove: (file) => {
        },
        beforeUpload: (file) => {
            dnaLibraryStore.setFilelist(file);
            fileToBase(file);
            return false;
        },
    };

    const fileToBase = (file: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            dnaLibraryStore.srcFile = reader.result;
        }
    }

    return (<Wrapper>
        <Form title={"基础库编辑"} form={form} layout={"vertical"} size={"middle"}
              style={{maxHeight: "400px", overflowY: "auto", overflowX: "hidden"}}>
            <Row gutter={24}>
                <Col span={8}><Form.Item label={"序列编号"} name={"sequenceNumber"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"采样编号"} name={"sampleNumber"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"药材名"} name={"medicineName"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"基原植物"} name={"originalPlant"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"拉丁名"} name={"latinName"} rules={[{required: true}]} required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"样品来源"} name={"sampleSource"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"取样部位"} name={"smapleLocation"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"样品提供单位"} name={"sampleUnit"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"鉴定人"} name={"appraiser"} required={false}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"责任人"} name={"dutyPerson"}
                                         required={false}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"序列提交时间"} name={"sequenceTime"}
                                         required={false}><DatePicker/></Form.Item></Col>
                <Col span={8}><Form.Item label={"序列类型"} name={"sequenceType"} rules={[{required: true}]}
                                         required={true}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"采集信息"} name={"collectInfo"}
                                         required={false}><Input/></Form.Item></Col>
                <Col span={8}><Form.Item label={"描述信息"} name={"describeInfo"} required={false}><Input/></Form.Item></Col>
                <Col span={8}>
                    <Upload style={{marginTop: "15px", marginBottom: "15px"}} showUploadList={false} name={"picture"}
                            maxCount={1} listType="picture-card" {...props} >
                        {(dnaLibraryStore.detailEntity?.imgUrl || dnaLibraryStore.srcFile) ? <Image preview={false}
                                                                                                        src={dnaLibraryStore.srcFile ? dnaLibraryStore.srcFile : BaseImageUrl + dnaLibraryStore.detailEntity?.imgUrl}
                                                                                                        fallback={defaultIcon}/> :
                            <UploadOutlined/>}
                    </Upload>
                </Col>
            </Row>
        </Form>
        <Button onClick={submit} type={"primary"} style={{width: "70px", left: "630px"}}>提交</Button>
    </Wrapper>);
}

export default observer(DnaEdit)

const Wrapper = styled.div`
  & {
    display: flex;
    flex-direction: column;
    padding: 20px 0 20px 0;
  }
`;